import React from "react";
import Header from "../../Components/Header";
import Feature from "../../Components/Feature";
import Footer from "../../Components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import OrderdetailRight from "../Layouts/OrderdetailRight";



export default function OrderDetail() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <OrderdetailRight />

       </div>
      </div>


      <Feature />
      <Footer />
    </div>
  );
}

